<template>
    <Card>

        <template slot="title">
            Reported Information
        </template>

        <template slot="actions">
            <Button
                size="sm"
                :disabled="loading"
                @click="refresh()"
            >
                Refresh
            </Button>
        </template>

        <template>
            <Spinner
                v-show="loading"
                class="content__spinner v-fade"
                size="large"
            />
            <div
                class="content"
                :class="{'content--loading': loading}"
            >
                <div class="mb-2">
                    <div class="font-weight-bold">
                        Price
                    </div>
                    <div>{{ formatCurrency(reportedInformation.reported_price) }}</div>
                </div>
                <div class="mb-2">
                    <div class="font-weight-bold">
                        Revenue
                    </div>
                    <div>{{ formatCurrency(reportedInformation.reported_revenue) }}</div>
                </div>
                <div class="mb-2">
                    <div class="font-weight-bold">
                        Profit
                    </div>
                    <div>{{ formatCurrency(reportedInformation.reported_profit) }}</div>
                </div>
                <div class="mb-2">
                    <div class="font-weight-bold">
                        Pipeline (Turnover)
                    </div>
                    <div>{{ formatCurrency(reportedInformation.pipeline_turnover) }}</div>
                </div>
                <div>
                    <div class="font-weight-bold">
                        Pipeline (Profit)
                    </div>
                    <div>{{ formatCurrency(reportedInformation.pipeline_profit) }}</div>
                </div>
            </div>
        </template>

    </Card>
</template>

<script>
import Card from '@/components/Card';
import * as helpers from '@/utils/helpers';

export default {

    components: {
        Card,
    },

    data() {
        return {
            loading: false,
        };
    },

    computed: {
        reportedInformation() {
            return this.$store.getters['costable/reportedInformation'];
        },
    },

    methods: {
        ...helpers,
        async refresh() {
            this.loading = true;
            await this.$store.dispatch('costable/refreshReportedInformation');
            this.loading = false;
        },
    },

};
</script>

<style lang="scss" scoped>
.content {
    position: relative;
    transition: opacity 0.25s ease-in-out;

    &__spinner {
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        top: 50%;
    }

    &--loading {
        opacity: 0.5;
        pointer-events: none;
        user-select: none;
    }
}
</style>
